import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField, Box, Paper, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import './GithubSearchBar.css';
import { useGithub } from '../../hooks/useGithub';
import { workMdIndex, resume } from '../../utils/fileIndex';

export default function GithubStyleSearch() {
    const [value, setValue] = useState(null);
    const { repos } = useGithub();
    const [options, setOptions] = useState([]);

    useEffect(() => {
        // Map work experience and resume to { name, link, type }
        const workOptions = workMdIndex.map(item => ({
            name: item.name,
            link: item.link,
            type: 'Work Experience'
        }));

        const resumeOption = {
            name: resume.name,
            link: resume.link,
            type: 'Resume'
        };

        const repoOptions = repos.map(repo => ({
            name: repo.name,
            link: repo.link, // correct property from GitHub API
            type: 'Repository'
        }));

        setOptions([...workOptions, resumeOption, ...repoOptions]);
    }, [repos]);

    const handleOptionSelect = (event, selectedOption) => {
        if (selectedOption && selectedOption.link) {
            // Open in current tab
            window.location.href = selectedOption.link;
        }
        // Clear the search bar
        setValue(null);
    };

    return (
        <Box className="github-search-container">
            <Autocomplete
                freeSolo
                options={options}
                getOptionLabel={(option) =>
                    option.type && option.name ? `${option.type}: ${option.name}` : ''
                }
                value={value}
                onChange={handleOptionSelect}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Search or jump to..."
                        variant="outlined"
                        className="github-search-input"
                        sx={{ backgroundColor: '#202020' }}
                        InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ color: '#9198a1' }} />
                                </InputAdornment>
                            )
                        }}
                    />
                )}
                PaperComponent={({ children }) => (
                    <Paper className="github-search-paper">{children}</Paper>
                )}
            />
        </Box>
    );
}
